/* eslint-disable @typescript-eslint/naming-convention */
import { createApp as createVueApp } from 'vue'
// @ts-ignore
import SocialSharing from 'vue-social-sharing'
// import axios from 'axios'
import App from './App.vue'
import { create as createRouter } from '../router'
import {
  createGraphql,
  DefaultApolloClient,
  GraphqlCacheSymbol,
} from '/@/core/graphql'
import Tracking from '/@/core/tracking'
import { type Config, createConfig } from '/@/core/config'
import CoreElements from '/@/core/elements'
import Rollbar from '/@/core/rollbar'
import vClipboard from '/@/core/v-clipboard'
import VueSafeTeleport from 'vue-safe-teleport'
import Stella from '/@/stella/index'
import * as amplitude from '@amplitude/analytics-browser'
import vDelayHover from '/@/core/v-delay-hover'

// todo: abstract it out of Viz
import DemoDirective from '/@/pages/Vizi/Edit/api/demo/directive'

// importing core styles
import '/@/core/styles/tailwind.css'
import '/@/core/styles/layout.scss'
import '/@/core/styles/typography.scss'
import '/@/core/styles/animations.scss'
import '/@/core/styles/reset.scss'
import { getCookie } from '../utils/cookie'

export async function createApp(conf: Config) {
  const app = createVueApp(App)
  const router = await createRouter()

  const config = createConfig(conf)

  app.use(router)
  app.__router = router

  app.use(Rollbar, {
    mode: config.mode,
    env: config.env,
    embed: config.embed,
    token: '422f528aec494fda843258929ca24ffe',
    url: window.location.href,
    version: config.version,
  })

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  app.config.errorHandler = function (err: any) {
    app.$rollbar.error(err)
    // eslint-disable-next-line
    console.error(err)
  }

  // app.component('Button', Button)
  app.use(CoreElements)
  app.use(Stella)
  app.use(SocialSharing)
  app.use(Tracking)
  app.use(vClipboard)
  app.use(vDelayHover)
  app.use(VueSafeTeleport)

  app.use(DemoDirective)

  const graphql = createGraphql(document.cookie, config)
  app.provide(DefaultApolloClient, graphql.client)
  app.provide(GraphqlCacheSymbol, graphql.cache)
  app.provide('pageUrl', window.location.href)

  if (config.apiKeys.amplitude) {
    const deviceId = getCookie(document.cookie, 'spk_anonymous_id')
    amplitude.init(config.apiKeys.amplitude, {
      defaultTracking: {
        pageViews: false,
      },
      deviceId,
    })
  }

  return {
    app,
    router,
    gqlClient: graphql.client,
  }
}
